import trainEvents from '../config/train-events';

export default function TrainsCarouselBaseController(
    $scope,
    $rootScope,
    $q,
    trainsFactory,
    flightsService,
    flightFareService
) {
    'ngInject';

    $scope.flightFareService = flightFareService;
    $scope.getFlightSupplierLogoSmall = flightsService.getFlightSupplierLogoSmall;
    $q.when(trainsFactory.getFlights()).then(function(flights) {
        $scope.matrix = flights;
    });

    $scope.sortComparison = function(comparisonFilter, airline) {
        $scope.carouselFilterApplied = true;

        trainsFactory.resetSegmentFilterData();
        $rootScope.$broadcast(trainEvents.CLEAR_SEGMENTS);
        trainsFactory.params.SegmentFilterData = [];

        $rootScope.$broadcast(trainEvents.COMPARISON_FILTER, {Airline: [airline]}, comparisonFilter);
    };
}



// WEBPACK FOOTER //
// ./src/app/modules/trains-base/controllers/trains-carousel-base-controller.js